import React from 'react'
import { useTranslation } from 'react-i18next'

import Container from '@components/common/layout/Container'

import i18n from '@src/config/i18n'
import locales from '@src/config/locales'

export default function MegaMenuFooter() {
  const { t } = useTranslation('revamp')
  const locale = i18n.language

  return (
    <div className='bg-revamp-red-700' style={{ height: '52px' }}>
      <Container className='flex text-base leading-mid items-center h-full'>
        <a className='hover:underline' href={t('contactUrl')}>
          {t('contact')}
        </a>
        <span className='mx-2'>|</span>
        <a className='hover:underline' href={locales[locale].faqPath}>
          {t('faq')}
        </a>
      </Container>
    </div>
  )
}
